// import React from 'react'

// const RockpayPrivacyPollicy = () => {
//   return (
//     <div>RockpayPrivacyPollicy</div>
//   )
// }

// export default RockpayPrivacyPollicy

// import React from 'react';
// import { 
//   Box, 
//   Typography, 
//   Container, 
//   Divider, 
//   Paper,
//   Card,
//   CardContent,
//   CardHeader,
//   Grid
// } from '@mui/material';
// import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';
// import SecurityIcon from '@mui/icons-material/Security';
// import InfoIcon from '@mui/icons-material/Info';
// import GavelIcon from '@mui/icons-material/Gavel';
// import HeaderTwo from './HeaderTwo';
// import FooterTwo from './FooterTwo';

// const RockkpayPrivacyPolicy = () => {
//   const currentDate = new Date().toLocaleDateString('en-US', {
//     year: 'numeric',
//     month: 'long',
//     day: 'numeric'
//   });

//   return (
    //  <>
    //     <HeaderTwo/>
//     <Container maxWidth="lg" sx={{ py: 4 }}>
//       <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
//         {/* Header Section */}
//         <Box textAlign="center" mb={4}>
//           <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: '#1976d2' }}>
//             <PrivacyTipIcon sx={{ mr: 1, fontSize: 40, verticalAlign: 'middle' }} />
//             RockkPay Privacy Policy
//           </Typography>
//           <Typography variant="subtitle1" color="text.secondary">
//             PAYSTREAM TECHNOLOGY PRIVATE LIMITED
//           </Typography>
//           <Typography variant="subtitle2" color="text.secondary" gutterBottom>
//             Registration Number: 07AAOCP7610E1ZD
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             Last Updated: {currentDate}
//           </Typography>
//         </Box>

//         <Divider sx={{ mb: 4 }} />

//         {/* Introduction */}
//         <Box mb={4}>
//           <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'medium', color: '#1976d2' }}>
//             <InfoIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
//             Introduction
//           </Typography>
//           <Typography variant="body1" paragraph>
//             PAYSTREAM TECHNOLOGY PRIVATE LIMITED ("we", "us", or "our") operates the RockkPay payment platform. 
//             We are committed to protecting your privacy and ensuring the security of your personal information. 
//             This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our RockkPay services.
//           </Typography>
//           <Typography variant="body1" paragraph>
//             By accessing or using RockkPay, you agree to the collection and use of information in accordance with this policy. 
//             We will not use or share your information with anyone except as described in this Privacy Policy.
//           </Typography>
//         </Box>

//         {/* Information We Collect */}
//         <Box mb={4}>
//           <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'medium', color: '#1976d2' }}>
//             <InfoIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
//             Information We Collect
//           </Typography>
//           <Typography variant="body1" paragraph>
//             <strong>Personal Information:</strong> We collect personally identifiable information that you provide to us, 
//             including but not limited to your name, email address, phone number, address, date of birth, PAN details, 
//             Aadhaar details, and bank account information. This information is collected during registration, KYC verification, 
//             and when you use our payment services.
//           </Typography>
//           <Typography variant="body1" paragraph>
//             <strong>Transaction Information:</strong> We collect details about the transactions you conduct through RockkPay, 
//             including transaction amounts, dates, times, merchant information, and payment methods used.
//           </Typography>
//           <Typography variant="body1" paragraph>
//             <strong>Device Information:</strong> We automatically collect certain information about your device, including IP address, 
//             device type, operating system, browser type, mobile network information, and the device's telephone number.
//           </Typography>
//           <Typography variant="body1" paragraph>
//             <strong>Log Data:</strong> Our servers automatically record information created by your use of RockkPay, including 
//             access times, pages viewed, interactions with the application, and system activity.
//           </Typography>
//         </Box>

//         {/* How We Use Your Information */}
//         <Box mb={4}>
//           <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'medium', color: '#1976d2' }}>
//             <InfoIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
//             How We Use Your Information
//           </Typography>
//           <Typography variant="body1" paragraph>
//             We use the collected information for various purposes, including:
//           </Typography>
//           <Typography variant="body1" paragraph>
//             • To provide, maintain, and improve our services<br />
//             • To process transactions and send related information<br />
//             • To verify your identity and comply with KYC requirements<br />
//             • To prevent fraudulent transactions and ensure the security of your account<br />
//             • To send service-related notifications and updates<br />
//             • To respond to your comments, questions, and requests<br />
//             • To communicate with you about products, services, offers, and promotions<br />
//             • To comply with legal obligations and regulatory requirements<br />
//             • To monitor usage patterns and analyze trends for improving user experience
//           </Typography>
//         </Box>

//         {/* Information Sharing and Disclosure */}
//         <Box mb={4}>
//           <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'medium', color: '#1976d2' }}>
//             <InfoIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
//             Information Sharing and Disclosure
//           </Typography>
//           <Typography variant="body1" paragraph>
//             We may share your personal information with:
//           </Typography>
//           <Typography variant="body1" paragraph>
//             <strong>Service Providers:</strong> We may employ third-party companies and individuals to facilitate our service, 
//             provide the service on our behalf, perform service-related tasks, or assist us in analyzing how our service is used. 
//             These third parties have access to your personal information only to perform these tasks on our behalf and are 
//             obligated not to disclose or use it for any other purpose.
//           </Typography>
//           <Typography variant="body1" paragraph>
//             <strong>Banking Partners and Payment Processors:</strong> To process transactions, we may share your information 
//             with our banking partners, payment processors, and financial institutions.
//           </Typography>
//           <Typography variant="body1" paragraph>
//             <strong>Legal Requirements:</strong> We may disclose your information if required to do so by law or in response 
//             to valid requests by public authorities (e.g., a court or a government agency).
//           </Typography>
//           <Typography variant="body1" paragraph>
//             <strong>Business Transfers:</strong> In the event of a merger, acquisition, or asset sale, your personal information 
//             may be transferred as a business asset. We will notify you before your personal information is transferred and becomes 
//             subject to a different Privacy Policy.
//           </Typography>
//         </Box>

//         {/* Data Security */}
//         <Box mb={4}>
//           <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'medium', color: '#1976d2' }}>
//             <SecurityIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
//             Data Security
//           </Typography>
//           <Typography variant="body1" paragraph>
//             The security of your personal information is important to us. We implement appropriate security measures to protect 
//             your personal information against unauthorized access, alteration, disclosure, or destruction. These measures include:
//           </Typography>
//           <Typography variant="body1" paragraph>
//             • Encryption of sensitive data using industry-standard protocols<br />
//             • Regular security assessments and penetration testing<br />
//             • Secure network architecture and firewalls<br />
//             • Access controls and authentication procedures<br />
//             • Regular security training for our staff
//           </Typography>
//           <Typography variant="body1" paragraph>
//             However, please be aware that no method of transmission over the internet or method of electronic storage is 100% secure. 
//             While we strive to use commercially acceptable means to protect your personal information, we cannot guarantee its absolute security.
//           </Typography>
//         </Box>

//         {/* Data Retention */}
//         <Box mb={4}>
//           <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'medium', color: '#1976d2' }}>
//             <InfoIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
//             Data Retention
//           </Typography>
//           <Typography variant="body1" paragraph>
//             We will retain your personal information only for as long as is necessary for the purposes set out in this Privacy Policy. 
//             We will retain and use your information to the extent necessary to comply with our legal obligations, resolve disputes, 
//             enforce our policies, and as required by applicable regulations.
//           </Typography>
//         </Box>

//         {/* Your Rights */}
//         <Box mb={4}>
//           <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'medium', color: '#1976d2' }}>
//             <GavelIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
//             Your Rights
//           </Typography>
//           <Typography variant="body1" paragraph>
//             You have the right to:
//           </Typography>
//           <Typography variant="body1" paragraph>
//             • Access the personal information we hold about you<br />
//             • Request correction of inaccurate or incomplete information<br />
//             • Request deletion of your personal information, subject to legal retention requirements<br />
//             • Object to processing of your personal information<br />
//             • Data portability (receiving a copy of your personal data)<br />
//             • Withdraw consent where processing is based on consent
//           </Typography>
//           <Typography variant="body1" paragraph>
//             To exercise these rights, please contact us using the information provided in the Contact Section.
//           </Typography>
//         </Box>

//         {/* Cookies and Tracking Technologies */}
//         <Box mb={4}>
//           <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'medium', color: '#1976d2' }}>
//             <InfoIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
//             Cookies and Tracking Technologies
//           </Typography>
//           <Typography variant="body1" paragraph>
//             We use cookies and similar tracking technologies to track activity on our service and hold certain information. 
//             Cookies are files with a small amount of data that may include an anonymous unique identifier. 
//             These are sent to your browser from a website and stored on your device.
//           </Typography>
//           <Typography variant="body1" paragraph>
//             You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. 
//             However, if you do not accept cookies, you may not be able to use some portions of our service.
//           </Typography>
//         </Box>

//         {/* Children's Privacy */}
//         <Box mb={4}>
//           <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'medium', color: '#1976d2' }}>
//             <InfoIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
//             Children's Privacy
//           </Typography>
//           <Typography variant="body1" paragraph>
//             Our services are not intended for use by individuals under the age of 18. We do not knowingly collect personal 
//             information from children under 18. If we become aware that we have collected personal information from a child 
//             under 18 without verification of parental consent, we will take steps to remove that information from our servers.
//           </Typography>
//         </Box>

//         {/* Changes to This Privacy Policy */}
//         <Box mb={4}>
//           <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'medium', color: '#1976d2' }}>
//             <InfoIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
//             Changes to This Privacy Policy
//           </Typography>
//           <Typography variant="body1" paragraph>
//             We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new 
//             Privacy Policy on this page and updating the "Last Updated" date at the top of this page.
//           </Typography>
//           <Typography variant="body1" paragraph>
//             You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are 
//             effective when they are posted on this page.
//           </Typography>
//         </Box>

//         {/* Contact Information */}
//         <Card sx={{ mb: 4, bgcolor: '#f5f5f5' }}>
//           <CardHeader title="Contact Information" />
//           <CardContent>
//             <Grid container spacing={2}>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle1" gutterBottom>
//                   <strong>Address:</strong>
//                 </Typography>
//                 <Typography variant="body2" paragraph>
//                   PAYSTREAM TECHNOLOGY PRIVATE LIMITED<br />
//                   Unit No.355, Plot No 4
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle1" gutterBottom>
//                   <strong>Data Protection Officer:</strong>
//                 </Typography>
//                 <Typography variant="body2" paragraph>
//                   Email: rockkpay@gmail.com<br />
//                 </Typography>
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>

//         {/* Consent */}
//         <Box textAlign="center">
//           <Typography variant="body1">
//             By using RockkPay, you consent to our Privacy Policy and agree to its terms.
//           </Typography>
//         </Box>
//       </Paper>
//     </Container>
    // <FooterTwo/>
    // </>
//   );
// };

// export default RockkpayPrivacyPolicy;

import React from 'react';
import { 
  Container, 
  Typography, 
  Paper, 
  Box, 
  Divider, 
  List, 
  ListItem, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow,
  useTheme,
  useMediaQuery
} from '@mui/material';
import HeaderTwo from './HeaderTwo';
import FooterTwo from './FooterTwo';

const RockpayPrivacyPolicy = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const sectionStyle = {
    marginBottom: theme.spacing(4),
  };

  const sectionTitleStyle = {
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main,
  };

  const subsectionTitleStyle = {
    fontWeight: 'bold',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  };

  const paragraphStyle = {
    marginBottom: theme.spacing(1.5),
    textAlign: 'justify',
  };

  const listItemStyle = {
    marginBottom: theme.spacing(1),
    display: 'block',
  };

  return (
    <>
        
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: isMobile ? 2 : 4, borderRadius: 2 }}>
        <Typography variant="h4" gutterBottom align="center" sx={{ fontWeight: 'bold', mb: 3 }}>
          Privacy Policy
        </Typography>

        {/* Section 1: SCOPE */}
        <Box sx={sectionStyle}>
          {/* <Typography variant="h5" sx={sectionTitleStyle}>
            1. SCOPE
          </Typography> */}
          {/* <Typography paragraph sx={paragraphStyle}>
            1. This internet resources and domains, www.vlnidhi.com, on the world wide web, and the application titled "Rockkpay" ("Application") is owned and hosted by <strong>PAYSTREAM TECHNOLOGY PRIVATE LIMITED</strong>, having its registered office at 2nd Floor Gondel Emporium Baner, under the brand name "ROCKKPAY" (hereinafter referred to as "ROCKKPAY", which also includes ROCKKPAY's affiliates, successors and assigns). ROCKKPAY is committed to protecting the User's information and privacy. ROCKKPAY facilitates the Users to make online rent payment, utility payments, GST payment, vendor payment, or such other business payments through the Application ("Services"), and shall include any other services provided by ROCKKPAY from time to time. Users agree to take full responsibility for the Transactions made on the platform with respect to nature of transaction, beneficiary and the tax implications pertaining to the same. For the purposes of this Privacy Policy, a <strong>Transaction</strong> means a payment instruction that results in the successful transfer of monies or settlement from a User to a payee.
          </Typography> */}

          <Typography paragraph sx={paragraphStyle}>
            1. This Privacy Policy is designed to help the User understand how ROCKKPAY may collect, process, store and use the information provided by the User to ROCKKPAY and to assist the User in making informed decision while using the Application and the Services.
          </Typography>

          <Typography paragraph sx={paragraphStyle}>
            2. The capitalized terms used in this Privacy Policy, but not defined in this Privacy Policy, shall have the meaning given to such terms in the Terms of Service available at [●].
          </Typography>

          <Typography paragraph sx={paragraphStyle}>
            3. The privacy of the personal information and data of the Users is important to ROCKKPAY. To better protect such privacy, ROCKKPAY has hereunder set out its privacy policy in relation to the Application (hereinafter referred to as the "Privacy Policy"). This Privacy Policy describes how ROCKKPAY will collect, receive, store, use, deal with, handle, manage, process, provide access to, share, disclose, protect and analyse the User Information (as defined below). Please read this Privacy Policy before using the Application or submitting any personal information.
          </Typography>

          <Typography paragraph sx={paragraphStyle}>
            4. This Privacy Policy has been published inter alia in compliance with the provisions of the Information Technology Act, 2000 and the rules and regulations made thereunder (including, but not limited to: (i) The Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011; and (ii) The Information Technology. (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021).
          </Typography>
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* Section 2: CONSENT TO THIS POLICY AND CHANGES IN POLICY */}
        <Box sx={sectionStyle}>
          <Typography variant="h5" sx={sectionTitleStyle}>
            2. CONSENT TO THIS POLICY AND CHANGES IN POLICY
          </Typography>
          <Typography paragraph sx={paragraphStyle}>
            1. By downloading and using the Application, the user ("User") expressly gives ROCKKPAY consent to collect, receive, store, use, deal with, handle, manage, process, provide access to, share, disclose to and analyse the User Information in the manner set forth in this Privacy Policy. <em>If the User does not agree to the terms of this Privacy Policy, please do not use or access the Application.</em>
          </Typography>

          <Typography paragraph sx={paragraphStyle}>
            2. By accessing the Application or by otherwise providing any User information, each User will be deemed to have read, understood and agreed to the terms and conditions outlined in the Privacy Policy and agree to be bound by the Privacy Policy. This Privacy Policy supercedes all previous oral and written terms and conditions (if any) communicated to a User, relating to use of / accessing the Application.
          </Typography>

          <Typography paragraph sx={paragraphStyle}>
            3. ROCKKPAY may, at any time, change, modify, add or delete any terms of the Privacy Policy, at its sole discretion, at any time, with or without advance notice. any such change, modification, addition or deletion of this Privacy Policy or any terms thereof shall be published on the Application to enable User(s) to review the same. Provided that apart from such publication, ROCKKPAY shall be under no obligation to inform or intimate the User(s) of any such change, modification, addition or deletion.
          </Typography>
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* Section 3: LINKS TO THIRD PARTY WEBSITES */}
        <Box sx={sectionStyle}>
          <Typography variant="h5" sx={sectionTitleStyle}>
            3. LINKS TO THIRD PARTY WEBSITES
          </Typography>
          <Typography paragraph sx={paragraphStyle}>
            1. The procedures and practices set forth in this Privacy Policy describe the use and disclosure of User Information collected by ROCKKPAY. The Application and/or other platforms of ROCKKPAY, as available may contain links to other websites. Any personal information about the User collected which such User visits such websites is not governed by this Privacy Policy. The User is encouraged to exercise caution and review the privacy policies applicable to such websites before accessing them. The User acknowledges that ROCKKPAY shall not be responsible for and has no control over the practices and content of any website accessed using the links contained on the Application.
          </Typography>
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* Section 4: COMPETENCY TO CONTRACT */}
        <Box sx={sectionStyle}>
          <Typography variant="h5" sx={sectionTitleStyle}>
            4. COMPETENCY TO CONTRACT
          </Typography>
          <Typography paragraph sx={paragraphStyle}>
            1. By agreeing to this Privacy Policy, a User (which such User is a natural Person) represents that the User is at least the age of majority i.e. 18 years, and is competent to contract. Additionally, where the User is registering on behalf of, and is the authorized representative of, a company, partnership or any other legal entity, such User has been duly authorized by such entity and is permitted under applicable laws to accept these Terms. In case the User is a natural person who is not of the age of majority or is not competent to contract, the User may not use the Application and/or the Services, or provide any information to ROCKKPAY.
          </Typography>
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* Section 5: INFORMATION COLLECTION */}
        <Box sx={sectionStyle}>
          <Typography variant="h5" sx={sectionTitleStyle}>
            5. INFORMATION COLLECTION
          </Typography>
          <Typography paragraph sx={paragraphStyle}>
            1. ROCKKPAY collects two basic types of information from a User in conjunction with a User's use of the Application i.e. personal information, which is any information that exclusively identifies a User (e.g., the User's name, postal address, date of birth, mobile/telephone phone number, email address, PAN, GST, financial information like bank account details, identification information amongst others) and non-personal information, which is information that does not exclusively identify a User but is related to the User nonetheless such as, information about a User's interests, demographics and use of the Application. ROCKKPAY may also receive personal information regarding a User as shared by third parties who maybe ROCKKPAY's clients or otherwise avail Service from ROCKKPAY. Please note that in such instances, ROCKKPAY is acting on the instructions provided by such User and ROCKKPAY does not separately verify the right of the User to provide User Information to ROCKKPAY. In case the User is not the intended recipient of the Services and/or the application, such User should contact ROCKKPAY at the earliest.
          </Typography>

          <Typography paragraph sx={paragraphStyle}>
            2. When the User accesses the Application to make Transactions, ROCKKPAY may collect information about the Transaction, as well as other information associated with the transaction such as amount sent or requested, amount paid for products or services, payee information, including information about any funding instruments used to complete the Transaction, device information, technical usage data, and geolocation of the User.
          </Typography>

          <Typography paragraph sx={paragraphStyle}>
            3. Towards the provision of the Services by ROCKKPAY and the use of the Application, ROCKKPAY shall in addition to the information described above, collect the following information from a user ("User Information"):
          </Typography>

          <TableContainer component={Paper} sx={{ my: 2, boxShadow: 'none', border: '1px solid rgba(224, 224, 224, 1)' }}>
            <Table aria-label="user information table">
              <TableHead>
                <TableRow sx={{ backgroundColor: theme.palette.primary.light }}>
                  <TableCell sx={{ fontWeight: 'bold', color: theme.palette.primary.contrastText }}>Category</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: theme.palette.primary.contrastText }}>Description</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>Location</TableCell>
                  <TableCell>Information about the location of the User's device used to access the application. This is used for the provision of the Services, pricing related information, for maintenance of records for audit purposes and other matters.</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>Access information</TableCell>
                  <TableCell>Passwords and other details required to access or use the Application and the Services provided by ROCKKPAY.</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>Personal information</TableCell>
                  <TableCell>Information about the name, email address, contact information and details of official documents. This is used for the provision of the Services and for maintenance of records for audit purposes.</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>Contacts</TableCell>
                  <TableCell>Information of contacts and accounts information to detect references and accounts information to autofill data during a User's requests for Services.</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>Other applications</TableCell>
                  <TableCell>The User's use of other websites or software or applications which are linked to the Application or used in the provision of the Services e.g. any third party sites though which a User may have accessed the Services.</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>Transaction</TableCell>
                  <TableCell>Transaction related information for Transactions conducted by Users through the Services. Transaction information includes price, quantity, and any associated or supporting data related to purchase. Transaction information is used to provide the Services, facilitate the Transactions, provide support, and to operate, maintain and improve the Services.</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>Billing Information</TableCell>
                  <TableCell>To the extent permitted and required under applicable laws, billing and payment information of Users which may include a subscription number, an account number, credit card number, expiration date, billing zip code, bitcoin-related information, exchange market information, instructions for wire transfers.</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>Automated collection</TableCell>
                  <TableCell>Details of the User's device, computer and device information, activity on the Application and other similar information. The Company collects this information for analytics, improvement of the Services and for review purposes.</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>Others</TableCell>
                  <TableCell>As may be explicitly required & requested from time to time.</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <Typography paragraph sx={paragraphStyle}>
            4. When the User uses the Services or access the Application, ROCKKPAY shall also collect Personal Data of the User and other payee such as name, postal address, telephone number, and financial account information about the payee who is receiving money from the User. Hence, the User should ensure that the User has obtained explicit consent of the payee to share, store, process and use its information as per this Privacy Policy.
          </Typography>

          <Typography paragraph sx={paragraphStyle}>
            5. ROCKKPAY may receive further information about the User that a User may voluntarily choose to provide ROCKKPAY, additional information required to resolve complaints, grievances or concerns as well as usage data. In arrangements with third parties, ROCKKPAY may gain access to the applications, services and features provided by the third parties.
          </Typography>

          <Typography paragraph sx={paragraphStyle}>
            6. ROCKKPAY shall use various technologies to collect information, including cookies and web beacons. Cookies are small data files that are typically stored on User's computer's hard drive or in device memory that help improve the Services and User's experience, see which areas and features of the Services are popular and count visits, manage the registration process for accounts, remember User's site preferences, retain certain information to process Transactions, chargeback requests (as defined in the Terms of Service) and retain information to provide User with support.
          </Typography>

          <Typography paragraph sx={paragraphStyle}>
            7. ROCKKPAY also use cookies stored in emails to confirm User's receipt of, and response to such emails. Web beacons are electronic images that may be used in the Services or emails and help deliver cookies, count visits, and understand usage and campaign effectiveness.
          </Typography>

          <Typography paragraph sx={paragraphStyle}>
            8. Information collected from cookies is used by ROCKKPAY to evaluate the effectiveness of the Application, analyse trends, probe into the difficulties that the visitors may experience in accessing the Application, and administer the Application.
          </Typography>
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* Continuing with remaining sections... */}
        <Box sx={sectionStyle}>
          <Typography variant="h5" sx={sectionTitleStyle}>
            6. TYPE OF INFORMATION NOT TO BE UPLOADED
          </Typography>
          <Typography paragraph sx={paragraphStyle}>
            1. While accessing or using the Application or the Services, User(s) shall ensure that the User(s) do NOT host, display, upload, modify, publish, transmit, update or share any information that:
          </Typography>

          <List>
            <ListItem sx={listItemStyle}>
              a. the User does not have a right to make available under any law or contractual or fiduciary relationship, unless the User owns or controls the rights thereto or have received all necessary consents for such use of the content;
            </ListItem>
            <ListItem sx={listItemStyle}>
              b. is defamatory, vulgar, obscene, pornographic, paedophilic, invasive of another person's privacy, including bodily privacy, insulting or harassing on the basis of gender, libellous, racially or ethnically objectionable, relating or encouraging money laundering or gambling, or otherwise inconsistent with or contrary to the laws in force;
            </ListItem>
            <ListItem sx={listItemStyle}>
              c. is harmful to minors and children;
            </ListItem>
            <ListItem sx={listItemStyle}>
              d. infringes patent, trademark, copyright or other proprietary rights or intellectual property rights of any person or entity;
            </ListItem>
            <ListItem sx={listItemStyle}>
              e. violates any applicable law, regulation or generally accepted practices or guidelines in India;
            </ListItem>
            <ListItem sx={listItemStyle}>
              f. deceives or misleads any other user of the Application, ROCKKPAY or any other person the origin of any messages on the Application or knowingly and intentionally communicates any information which is patently false or misleading in nature but may reasonably be perceived as a fact;
            </ListItem>
            <ListItem sx={listItemStyle}>
              g. impersonates any person or entity, or falsely state or otherwise misrepresents the User's affiliation with a person or entity;
            </ListItem>
            <ListItem sx={listItemStyle}>
              h. the unity, integrity, defence, security or sovereignty of India, friendly relations with foreign States, or public order, or causes incitement to the commission of any cognisable offence or prevents investigation of any offence or is insulting other nation;
            </ListItem>
            <ListItem sx={listItemStyle}>
              i. contains viruses, trojan horses, worms, spyware, time bombs, cancelbots, or other computer programming routines, code, files or such other programs that may harm the Services or the Application, interests or rights of other users or limit the functionality of any computer software, hardware or telecommunications, or that may harvest or collect any data or personal information about other Users or the payees without their consent;
            </ListItem>
            <ListItem sx={listItemStyle}>
              j. is patently false and untrue, and is written or published in any form, with the intent to mislead or harass a person, entity or agency for financial gain or to cause any injury to any person;
            </ListItem>
          </List>

          <Typography paragraph sx={paragraphStyle}>
            2. The User shall not (a) use the Services or the Application for commercial purposes of any kind, or (b) advertise or sell the Services or the Application or domain names or otherwise (whether or not for profit), or solicit others (including, without limitation, solicitations for contributions or donations) or use any public forum for commercial purposes of any kind, or (c) use the Services or the Application in any way that is unlawful, or harms ROCKKPAY.
          </Typography>

          <Typography paragraph sx={paragraphStyle}>
            3. Notwithstanding the generality of the foregoing Clause, Users agree and undertake that the Users shall not upload any information / data on the Application, which would infringe the intellectual property rights of any third person.
          </Typography>

          <Typography paragraph sx={paragraphStyle}>
            4. Each User agrees to absolve ROCKKPAY from and indemnify ROCKKPAY against any and all claims that may arise as a result of any third-party claiming infringement of intellectual property rights that may arise from any User uploading any information / data on the Application.
          </Typography>
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* Continuing with remaining sections... */}
        <Box sx={sectionStyle}>
          <Typography variant="h5" sx={sectionTitleStyle}>
            7. PURPOSE OF COLLECTION AND USAGE OF INFORMATION
          </Typography>
          <Typography paragraph sx={paragraphStyle}>
            1. User Information will be used by ROCKKPAY for the purposes which ROCKKPAY considers necessary for achieving a seamless, efficient and safe experience, customized to a User's needs and use the personal information to provide Services to a User, enhance the operation of the services and improve ROCKKPAY's marketing and promotional efforts. The processing of the User's Information is for the purposes of:
          </Typography>

          <List>
            <ListItem sx={listItemStyle}>
              a. to provide, maintain and enhance a User experience in relation to the Application;
            </ListItem>
            <ListItem sx={listItemStyle}>
              b. to provide and deliver the Services requested by the User, process Transaction, and send User related information including confirmations and invoices;
            </ListItem>
            <ListItem sx={listItemStyle}>
              c. to authenticate the Users' KYC documents;
            </ListItem>
            <ListItem sx={listItemStyle}>
              d. to perform creditworthiness and other financial standing checks, evaluate applications, and compare information for accuracy and verification purposes;
            </ListItem>
            <ListItem sx={listItemStyle}>
              e. to send technical notices, updates, security alerts, and support and administrative messages to the User;
            </ListItem>
            <ListItem sx={listItemStyle}>
              f. to take up and investigate any complaints/ claim/ disputes;
            </ListItem>
            <ListItem sx={listItemStyle}>
              g. to respond to the queries or feedback submitted by the User;
            </ListItem>
            <ListItem sx={listItemStyle}>
              h. to monitor and analyze trends, usage, and activities in connection with the Services;
            </ListItem>
            <ListItem sx={listItemStyle}>
              i. to link or combine with information ROCKKPAY receives from others to understand User's needs and provide better service;
            </ListItem>
            <ListItem sx={listItemStyle}>
              j. to carry out any other purpose for which the information was collected;
            </ListItem>
            <ListItem sx={listItemStyle}>
              k. to inform the Users of online and offline offers, products, services, and updates on the Application;
            </ListItem>
            <ListItem sx={listItemStyle}>
              l. to detect and protect ROCKKPAY against error, fraud and other criminal activity;
            </ListItem>
            <ListItem sx={listItemStyle}>
              m. to comply with the applicable laws and regulations this Privacy Policy; and
            </ListItem>
            <ListItem sx={listItemStyle}>
              n. to share the data such as back testing, user action and processed data for internal and external services with the third parties without User's consent.
            </ListItem>
          </List>

          <Typography paragraph sx={paragraphStyle}>
            2. <strong>SMS Data Access:</strong> ROCKKPAY may request access to your SMS data stored on your mobile device. By granting us this access, you allow us to collect and securely store your financial and transactional SMS data. ROCKKPAY values your privacy and is committed to protecting your personal information. When you grant us access to your SMS data, we securely collect only your financial and transactional SMS information. This allows us to analyse your financial profile, process transactions, verify payment details, and optimise your user experience. We collect this data for the following purposes:
          </Typography>

          <List>
            <ListItem sx={listItemStyle}>
              a. Verification and Security: Access to your SMS data enables us to verify the ownership and validity of credit cards used for payments, enhancing security and preventing fraudulent activities.
            </ListItem>
            <ListItem sx={listItemStyle}>
              b. User Experience Optimization: We utilise SMS data to provide accurate and near real-time information that helps you during the payment process and other app experiences.
            </ListItem>
            <ListItem sx={listItemStyle}>
              c. Payment Mode Analysis: We analyse your payment modes based on the SMS data to provide you with the best payment options and services tailored to your needs.
            </ListItem>
            <ListItem sx={listItemStyle}>
              d. Transaction Processing: Your SMS data helps us securely process transactions accurately and efficiently, ensuring seamless payments.
            </ListItem>
          </List>

          <Typography paragraph sx={paragraphStyle}>
            We do not access personal SMS messages unrelated to financial and transactional information. You have the right to revoke your consent and disable SMS access at any time, although certain services may be limited without this access. We implement appropriate security measures to protect your SMS data from unauthorized access or misuse. At ROCKKPAY, we prioritize the privacy and security of your personal information. We employ industry-standard practices to safeguard your data and retain it only as long as necessary. You have the right to opt out of SMS access, and we will handle your data in compliance with legal and regulatory requirements. For any questions or concerns about our Privacy Policy or the collection of SMS data, please contact us using the provided contact information.
          </Typography>
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* Additional sections... */}
        <Box sx={sectionStyle}>
          <Typography variant="h5" sx={sectionTitleStyle}>
            8. INFORMATION STORAGE AND DISSEMINATION
          </Typography>
          <Typography paragraph sx={paragraphStyle}>
            1. User Information is stored on ROCKKPAY's database servers or hosted by third parties who have entered into agreements with ROCKKPAY that require them to observe this Privacy Policy. Such data centres may be located in India or outside India. ROCKKPAY ensures that data centres are designed to be physically secure and protected from unauthorized access of User Information by unauthorized persons.
          </Typography>
          
          <Typography paragraph sx={paragraphStyle}>
            2. Storage and transfer of User Information is carried out in compliance with all applicable laws, including without limitation, the Information Technology Act, 2000 and the Information Technology (Reasonable security practices and procedures and sensitive personal data or information) Rules, 2011. Please note that the Services have reasonable security measures, including as mentioned in Information Technology Act, 2000 in place to protect the loss or misuse of the User Information. Whenever a User changes or access the User's account information, ROCKKPAY offers the use of a secure server. However, the User acknowledges that transacting over the internet has inherent risks which can only be avoided by the User following reasonable security practices, such as not revealing account/login related information to any other person and informing ROCKKPAY's customer care team about any suspicious activity or where the User's account has/may have been compromised.
          </Typography>
          
          {/* Additional paragraphs here... */}
          
          <Typography paragraph sx={paragraphStyle}>
            3. ROCKKPAY implements reasonable security practices and procedures and have a comprehensive documented information security programme and information security policies that contain managerial, technical, operational and physical security control measures that are commensurate with respect to the information being collected and the nature of ROCKKPAY's business. ROCKKPAY has put in place appropriate physical, electronic and managerial procedures to safeguard and help prevent unauthorized access, maintain data security, and correctly use the User Information ROCKKPAY collects online.
          </Typography>
          
          {/* Continue with all paragraphs for section 8... */}
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* Continue with remaining sections... */}
        
        <Box sx={sectionStyle}>
          <Typography variant="h5" sx={sectionTitleStyle}>
            17. COMMUNICATIONS / GRIEVANCES
          </Typography>
          <Typography paragraph sx={paragraphStyle}>
            1. In the event of any grievances from access or use of the Application and / or Services, such User should immediately contact the Grievance Officer at the following:
          </Typography>
          
          <TableContainer component={Paper} sx={{ my: 2, boxShadow: 'none', border: '1px solid rgba(224, 224, 224, 1)' }}>
            <Table aria-label="contact information table">
              <TableBody>
                <TableRow>
                  <TableCell component="th" scope="row" sx={{ fontWeight: 'bold', width: '30%' }}>Name:</TableCell>
                  <TableCell>PAYSTREAM TECHNOLOGY PRIVATE LIMITED</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>Address:</TableCell>
                  <TableCell>
Unit No.355,Plot No 4,NEW DELHI,Delhi,110085,
REGISTRATION NUMBER-07AAOCP7610E1ZD</TableCell>
                </TableRow>
                {/* <TableRow>
                  <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>Kind Atten:</TableCell>
                  <TableCell></TableCell>
                </TableRow> */}
                <TableRow>
                  <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>E-mail:</TableCell>
                  <TableCell>rockkpay@gmail.com</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>Timings:</TableCell>
                  <TableCell>Mon -- Sat, 10AM -- 7PM</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        
        <Box sx={{ textAlign: 'center', mt: 4 }}>
          <Typography variant="body2" color="textSecondary">
            © {new Date().getFullYear()} PAYSTREAM TECHNOLOGY PRIVATE LIMITED. All rights reserved.
          </Typography>
        </Box>
      </Paper>
    </Container>
        
        </>
  );
};

export default RockpayPrivacyPolicy;